export enum EmailTemplateType {
  VERIFY = 'VERIFY',
  INVOICE = 'INVOICE',
  REMINDER = 'REMINDER',
}
